import { toast } from 'react-toastify';

import { cohortActions } from '../../../../../../store';

import type { AppDispatch } from '../../../../../../store';

type DeleteCohortAssignmentAndRefreshParams = {
  dispatch: AppDispatch;
  getAccessTokenSilently: () => Promise<string>;
  assignmentId: number;
  clientId: string | undefined;
  onSuccess: () => void;
};

export const deleteCohortAssignmentAndRefresh = async ({
  dispatch,
  getAccessTokenSilently,
  assignmentId,
  clientId,
  onSuccess,
}: DeleteCohortAssignmentAndRefreshParams): Promise<void> => {
  try {
    const response = await dispatch(
      cohortActions.deleteClientCohortAssignment({
        assignmentId,
        getAccessTokenSilently,
      }),
    );
    if (!response.error) {
      dispatch(
        cohortActions.getClientCohortAssignments({
          params: { client_id: clientId },
          getAccessTokenSilently,
        }),
      );
      onSuccess();
    }
  } catch (error) {
    toast.error(`Error deleting contract:${error}`);
  }
};
